module.exports = __webpack_public_path__ + "media/images/sp/top/area_brand_sola-87622e209a9ae7b113b1f50ff65ad857.webp";